import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import LoadSpinner from "../../components/LoadingSpinner";
import { useGlobalContext } from "../../context/GlobalContext";
import NotFound from "../../components/NotFound";
import ProfilePreview from "../../components/ProfilePreview";
import Footer from "../../components/Footer";
import { analyticsHandler } from "../../services/firebase/googleAnalytics";
import {getProfileDetails, getSuggestedProfiles} from '../../services/api/profile'

const ProfileDetailView: React.FC = () => {
  const { id } = useParams();
  const { user, setCurrentProfile, currentProfile, setIsLoading, isLoading } = useGlobalContext();
  const [showNotFound, setShowNotFound] = useState<boolean>(false);

  useEffect(() => {    
    (async () => {
      setIsLoading(true);
      try {
        const list = await getProfileDetails(id);
        setCurrentProfile(list?.data);
        analyticsHandler("profile_visit", {name: list?.data?.name, id: list?.data?.id})
        setShowNotFound(false);
        // Fetch suggested profiles silently
        try {
          const suggestedList = await getSuggestedProfiles(list?.data?.id);
          setCurrentProfile((prev: any) => ({ ...prev, suggestedResources: suggestedList?.data || [] }));
        } catch (suggestedError) {
          console.error("Error fetching suggested profiles:", suggestedError);
        }
      } catch (error: any) {
        console.error("Error fetching resource summary:", error);
        error?.status === 404 && setShowNotFound(true);
      }
      setIsLoading(false);
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {!showNotFound ? (
        <>
          {isLoading ? (
            <div className="flex items-center justify-center h-screen w-full h-100">
              <LoadSpinner />
            </div>
          ) : (
            <>
              <ProfilePreview
                currentProfile={currentProfile}
                showBreadCrumbs={true}
                showHeading={Object.keys(user).length > 0}
              />
            </>
          )}
        </>
      ) : (
        <NotFound />
      )}
      <Footer/>
    </>
  );
};

export default ProfileDetailView;